module.exports = __webpack_public_path__ + "img/onDemand_bg.0c1db4a1.png";